module.exports = __webpack_public_path__ + "static/media/pw-wins-icon.49020312.svg";